import { useRef, useState } from "react";
import Button from "../basic/Button";
import ic_google from "../../assets/icons/ic_google.svg";
import ic_facebook from "../../assets/icons/ic_facebook_filled.svg";
import {
  checkLogin,
  getEmailExists,
  resetPassword,
  sendEmailOtp,
  verifyEmailOtp,
} from "../../api/api";
import { useAuthContext } from "../../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { validateEmail, validPhone } from "../../utils/Utils";
import { Icon } from "@iconify/react";
import OtpInput from "../basic/OtpInput";
import useIsMobile from "../../utils/useIsMobile";

function ForgotPasswordDialog({ userEmail, onPasswordChanged }) {
  const [email, setEmail] = useState(userEmail);
  const [hash, setHash] = useState();
  const [otp, setOtp] = useState();
  const [otpVerified, setOtpVerified] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [passwordInputType, setPasswordInputType] = useState("password");
  const [confirmPasswordInputType, setConfirmPasswordInputType] =
    useState("password");

  const [sendOtpEnabled, setSendOtpEnabled] = useState(true);

  async function sentOtp() {
    if (sendOtpEnabled) {
      setSendOtpEnabled(false);
      if (validateEmail(email)) {
        const validEmail = await getEmailExists(email);
        if (validEmail.userFound) {
          const response = await sendEmailOtp(email);
          if (response.success) {
            toast("OTP Sent");
            setHash(response.hash);
          }
        } else {
          toast("User does not exists");
        }
      } else {
        toast("Invalid Email");
      }
      setSendOtpEnabled(true);
    }
  }

  async function verifyOtp() {
    if (otp.length == 4) {
      const response = await verifyEmailOtp(email, otp.toString(), hash);
      if (response.success) {
        setOtpVerified(true);
      } else {
        toast("Invalid OTP", { type: "error" });
        setOtp(null);
      }
    }
    // else if (otp.length === 0) {
    //   toast("OTP required", { type: "error" });
    // }
    else {
      toast("OTP should be 4 digits", { type: "error" });
    }
  }

  async function performResetPassword() {
    if (password.length < 8) {
      toast("Password must be at least 8 characters long", { type: "error" });
      return;
    } else {
      const response = await resetPassword(email, password);
      if (response.success) {
        toast("Password reset successful");
        onPasswordChanged(email, password);
      } else {
        toast(response.msg);
      }
    }
  }

  return (
    <div className="mt-5">
      {!hash ? (
        <div className="flex flex-col justify-center items-center">
          <p className="text-customGray-500 font-bold text-center ">
            Please enter the Email Associated with your account, we’ll send a
            code to reset your password
          </p>
          <input
            className="px-4 py-3 mt-5 rounded-lg border-[1px] border-gray-300 w-full bg-transparent text-white placeholder-[#667085]"
            placeholder="Email"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <Button
            className={" self-center px-4 py-2  mt-10"}
            type="primary"
            onClick={() => sentOtp()}
            disabled={!sendOtpEnabled}
          >
            Send OTP
          </Button>
        </div>
      ) : !otpVerified ? (
        <div className="flex items-center flex-col">
          <p className="font-bold text-customGray-500">
            Please enter the Code sent to your {email} to reset your password
          </p>
          <OtpInput
            onOtpChanged={(otp) => {
              setOtp(otp);
            }}
            // otp={otp}
          />

          <Button
            onClick={async () => {
              verifyOtp();
            }}
            type="primary"
            className={"px-4 mt-6 self-center"}
          >
            Verify
          </Button>
          <p
            className={
              "text-orange-800 border-orange-800 px-4 py-2 text-base font-bold underline cursor-pointer"
            }
            onClick={() => {
              sentOtp();
            }}
          >
            Resend
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          <div className="px-4 py-3 flex flex-row  rounded-lg items-center  border-[1px] bg-transparent border-gray-300 ">
            <input
              className="bg-transparent flex flex-1  placeholder-[#667085] outline-none text-white"
              placeholder="Password"
              value={password}
              type={passwordInputType}
              onChange={(e) => {
                if (e.target.value.length > 0)
                  if (!e.target.value.match(/^[\S]+$/)) {
                    toast("Spaces are not allowed in password");
                  } else {
                    setPassword(e.target.value);
                  }
                else {
                  setPassword("");
                }
              }}
            />
            <Icon
              icon={
                passwordInputType === "password"
                  ? "akar-icons:eye"
                  : "akar-icons:eye-slashed"
              }
              color="#667085"
              onClick={() => {
                setPasswordInputType(
                  passwordInputType === "password" ? "text" : "password"
                );
              }}
              className="w-5 h-5"
            />
          </div>

          <div className="px-4 py-3 flex flex-row rounded-lg items-center  border-[1px] bg-transparent border-gray-300 ">
            <input
              className="bg-transparent flex flex-1  placeholder-[#667085] outline-none text-white"
              placeholder="Confirm Password"
              value={confirmPassword}
              type={confirmPasswordInputType}
              onChange={(e) => {
                if (e.target.value.length > 0)
                  if (!e.target.value.match(/^[\S]+$/)) {
                    toast("Spaces are not allowed in password");
                  } else {
                    setConfirmPassword(e.target.value);
                  }
                else {
                  setConfirmPassword("");
                }
              }}
            />
            <Icon
              icon={
                confirmPasswordInputType === "password"
                  ? "akar-icons:eye"
                  : "akar-icons:eye-slashed"
              }
              color="#667085"
              onClick={() => {
                setConfirmPasswordInputType(
                  confirmPasswordInputType === "password" ? "text" : "password"
                );
              }}
              className="w-5 h-5"
            />
          </div>
          <Button
            onClick={async () => {
              if (password == confirmPassword) performResetPassword();
              else {
                toast("Password does not match");
              }
            }}
            type="primary"
            className={"px-4 mt-6 self-center"}
          >
            Done
          </Button>
        </div>
      )}
    </div>
  );
}

function LoginStep2({
  loginThrough,
  hash,
  email,
  mobile,
  resendOtp,
  closeDialog,
  setShowForgetPassword,
}) {
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [passwordInputType, setPasswordInputType] = useState("password");
  const navigate = useNavigate();
  const auth = useAuthContext();
  const location = useLocation();

  async function performLogin() {
    if (otp.length != 4 && loginThrough == "mobile") {
      toast("Otp must be 4 digits");
      // setOtp(null);
      return;
    }
    let data;
    if (loginThrough == "email") {
      data = await auth.login({ email: email, password: password });
    } else if (loginThrough == "mobile") {
      data = await auth.login({
        mobile: mobile,
        otp: otp,
        hash: hash,
      });
    }
    if (data) {
      closeDialog();
      if (location.state?.from?.search) {
        navigate(location.state.from.pathname + location.state.from.search);
      } else {
        navigate("/programpage");
      }
    }
  }
  return (
    <div className="w-full flex flex-col items-center">
      {loginThrough == "email" && (
        <div className="px-4 py-3 w-full mt-2 flex flex-row rounded-lg items-center  border-[1px] bg-transparent border-gray-300 ">
          <input
            className="bg-transparent flex flex-1 w-full placeholder-[#667085] outline-none text-white"
            placeholder="PASSWORD"
            value={password}
            type={passwordInputType}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          <Icon
            icon={
              passwordInputType === "password"
                ? "akar-icons:eye"
                : "akar-icons:eye-slashed"
            }
            color="#667085"
            onClick={() => {
              setPasswordInputType(
                passwordInputType === "password" ? "text" : "password"
              );
            }}
            className=" w-5 h-5"
          />
        </div>
      )}

      {loginThrough == "email" && (
        <p
          className="text-right w-full font-open-sans text-white text-opacity-70 mt-2 text-sm hover:cursor-pointer underline font-medium"
          onClick={() => setShowForgetPassword(true)}
        >
          Forgot Password ?
        </p>
      )}
      {loginThrough == "mobile" && (
        <div>
          <OtpInput
            onOtpChanged={(otp) => {
              setOtp(otp);
            }}
            // otp={otp}
          />
          <p
            className="text-primary-gray w-full text-end mt-3 cursor-pointer underline"
            onClick={() => {
              resendOtp();
            }}
          >
            Resend
          </p>
        </div>
      )}
      <Button
        onClick={() => {
          performLogin();
        }}
        type="primary"
        className={"flex self-center mt-6"}
      >
        Login
      </Button>
    </div>
  );
}

function LoginDialog({ closeDialog }) {
  const [emailOrPhone, setEmailorPhone] = useState("");

  const [loginThrough, setLoginThrough] = useState("");
  const [hash, setHash] = useState("");
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const navigate = useNavigate();
  const auth = useAuthContext();
  const location = useLocation();
  const isMobile = useIsMobile();

  async function handleNext(emailOrPhone, isEmail) {
    const data = await checkLogin(
      isEmail ? emailOrPhone : "+91" + emailOrPhone
    );
    if (data) {
      if (data.found) {
        if (data.loginThrough == "mobile") {
          setHash(data.hash);
          toast("OTP sent");
        }
        setLoginThrough(data.loginThrough);
      } else {
        navigate("/register", {
          state: {
            email: isEmail ? emailOrPhone : null,
            phone: !isEmail ? emailOrPhone : null,
            registerThrough: isEmail ? "email" : "mobile",
          },
        });
        closeDialog();
      }
    } else {
      toast("Some error occurred");
      closeDialog();
    }
  }

  const login = useGoogleLogin({
    onSuccess: googleLoginSuccess,
  });

  async function googleLoginSuccess(data) {
    if (data) {
      const response = await fetch(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${data.access_token}`,
        {
          method: "GET",
        }
      ).then((res) => {
        return res.json();
      });
      if (response) {
        const loginResponse = await auth.socialMediaLogin({
          type: "google",
          id: response.id,
          email: response.email,
        });
        if (loginResponse) {
          closeDialog();
          if (location.state?.from?.search) {
            navigate(location.state.from.pathname + location.state.from.search);
          } else {
            navigate("/programpage");
          }
        } else {
          navigate("/register", {
            state: {
              fullname: response.name,
              socialLogin: true,
              google_id: response.id,
              email: response.email,
              registerThrough: "social",
            },
          });
          closeDialog();
        }
      } else {
        toast("Google Login failed");
      }
    } else {
      toast("Google Login failed");
    }
  }

  async function facebookLoginResponse(data) {
    if (data.id) {
      const response = await auth.socialMediaLogin({
        type: "facebook",
        id: data.id,
        email: data.email,
      });
      if (response) {
        closeDialog();
        if (location.state?.from?.search) {
          navigate(location.state.from.pathname + location.state.from.search);
        } else {
          navigate("/programpage");
        }
      } else {
        navigate("/register", {
          state: {
            fullname: data.name,
            socialLogin: true,
            facebook_id: data.id,
            email: data.email,
            registerThrough: "social",
          },
        });
        closeDialog();
      }
    }
  }
  return (
    <>
      <div
        as="h2"
        className=" text-2xl md:text-4xl font-bold text-center font-poppins text-white"
      >
        {showForgetPassword ? "Forgot Password?" : "LOGIN / SIGN UP"}
      </div>
      <div className="px-4 md:px-16 py-9">
        {showForgetPassword ? (
          <ForgotPasswordDialog
            userEmail={emailOrPhone}
            onPasswordChanged={async (email, password) => {
              const data = await auth.login({ email, password });
              if (data) {
                closeDialog();
                if (location.state?.from?.search) {
                  navigate(
                    location.state.from.pathname + location.state.from.search
                  );
                } else {
                  navigate("/programpage");
                }
              }
            }}
          />
        ) : (
          <div className="flex flex-col items-center">
            <p className="font-bold text-white font-poppins w-full text-start">
              {loginThrough == ""
                ? "Mobile number or Email id"
                : // "Mobile Number/E-mail id"
                loginThrough == "email"
                ? "Enter password"
                : "Enter OTP"}
            </p>
            {loginThrough == "" ? (
              <div className="w-full flex flex-col items-center">
                <input
                  value={emailOrPhone}
                  className="px-4 py-3 mt-5 rounded-lg border-[1px] bg-transparent text-white placeholder-primary-gray border-gray-300 w-full"
                  placeholder={
                    isMobile
                      ? "Mobile/Email Address"
                      : "9876543210 or john@xyz.com"
                  }
                  onChange={(e) => {
                    setEmailorPhone(e.target.value);
                  }}
                />
                <Button
                  onClick={() => {
                    if (validateEmail(emailOrPhone)) {
                      handleNext(emailOrPhone, true);
                    } else if (validPhone(emailOrPhone)) {
                      handleNext(emailOrPhone, false);
                    } else {
                      toast("Enter a valid mobile number or email", {
                        type: "error",
                      });
                    }
                  }}
                  type="primary"
                  className={"flex self-center mt-6"}
                >
                  Next
                </Button>
              </div>
            ) : (
              <LoginStep2
                email={validateEmail(emailOrPhone) ? emailOrPhone : null}
                mobile={validPhone(emailOrPhone) ? "+91" + emailOrPhone : null}
                hash={hash}
                closeDialog={closeDialog}
                loginThrough={loginThrough}
                resendOtp={() => {
                  if (validateEmail(emailOrPhone)) {
                    handleNext(emailOrPhone, true);
                  } else if (validPhone(emailOrPhone)) {
                    handleNext(emailOrPhone, false);
                  } else {
                    toast("Enter a valid mobile numer or email", {
                      type: "error",
                    });
                  }
                }}
                setShowForgetPassword={setShowForgetPassword}
              />
            )}
            <div className="flex flex-row space-x-4 items-center mt-5 w-full">
              <div className="w-full h-[2px] bg-new-gray" />
              <p className="text-gray-200 font-medium">or</p>
              <div className="w-full h-[2px] bg-new-gray" />
            </div>
            <div className="flex flex-row mt-6 justify-center items-center space-x-6">
              <button
                className="py-2 px-2 font-medium flex flex-row justify-center items-center rounded-full border-[1px] border-white"
                onClick={() => login()}
              >
                <img src={ic_google} className="w-8 h-8" />
              </button>
              <FacebookLogin
                appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                fields="name,email"
                callback={facebookLoginResponse}
                render={(renderProps) => {
                  return (
                    <button
                      className="py-2 px-2  font-medium flex flex-row items-center justify-center rounded-full border-[1px] border-white"
                      onClick={renderProps.onClick}
                    >
                      <img src={ic_facebook} className="w-8 h-8" />
                    </button>
                  );
                }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default LoginDialog;
